let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Rr5F")).then(() => parcelRequire('jEjtf'));